import { useState } from "react";
import httpClient from "../../../custom-hooks/httpClient";
import { toast } from "react-toastify";
import Modal from "../../Modal";
import { BeneficiaryList, ConfirmDeleteModal } from "./Shared";

function WalletBeneficiariesModal({
  beneficiaries,
  setBeneficiaries,
  handleBeneficiarySelection,
  showModal,
  setShowModal,
}) {
  const [confirmDeleteId, setConfirmDeleteId] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");

  const handleConfirmDelete = async () => {
    try {
      const { status, data } = await httpClient.delete(
        `/beneficiaries/${confirmDeleteId}`,
      );
      if (status === 200) {
        setBeneficiaries((prevBeneficiaries) =>
          prevBeneficiaries.filter((b) => b.id !== confirmDeleteId),
        );
        toast.success(data.message || "Beneficiary deleted successfully!");
        setConfirmDeleteId(null);
      }
    } catch (err) {
      toast.error(err.response?.data.message || "Error deleting beneficiary!");
      setConfirmDeleteId(null);
    }
  };

  // Wallet beneficiaries only (those without a bank code).
  const filterBeneficiaries = beneficiaries.filter((b) => !b.bank_code);

  return (
    <Modal
      showModal={showModal}
      setShowModal={setShowModal}
      title=""
      showTitle={false}
      clickOut={true}
      noPadding
    >
      <BeneficiaryList
        beneficiaries={filterBeneficiaries}
        searchQuery={searchQuery}
        onSearchChange={setSearchQuery}
        onClose={() => setShowModal(false)}
        onSelect={handleBeneficiarySelection}
        onDelete={setConfirmDeleteId}
        getSubLabel={(b) => b.recipient_account_number}
      />

      <ConfirmDeleteModal
        confirmDeleteId={confirmDeleteId}
        beneficiaries={beneficiaries}
        onCancel={() => setConfirmDeleteId(null)}
        onConfirm={handleConfirmDelete}
      />
    </Modal>
  );
}

export default WalletBeneficiariesModal;
